"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswersCore = void 0;
/**
 * Provides methods for executing searches, submitting questions, and performing autocompletes.
 *
 * @public
 */
class AnswersCore {
    /** @internal */
    constructor(searchService, questionSubmissionService, autoCompleteService) {
        this.searchService = searchService;
        this.questionSubmissionService = questionSubmissionService;
        this.autoCompleteService = autoCompleteService;
    }
    /**
     * Performs an Answers search across all verticals.
     *
     * @param request - Universal search request options
     */
    universalSearch(request) {
        return this.searchService.universalSearch(request);
    }
    /**
     * Performs an Answers search for a single vertical.
     *
     * @param request - Vertical search request options
     */
    verticalSearch(request) {
        return this.searchService.verticalSearch(request);
    }
    /**
     * Submits a custom question to the Answers API.
     *
     * @param request - Question submission request options
     */
    submitQuestion(request) {
        return this.questionSubmissionService.submitQuestion(request);
    }
    /**
     * Performs an autocomplete request across all verticals.
     *
     * @param request - Universal autocomplete request options
     */
    universalAutoComplete(request) {
        return this.autoCompleteService.universalAutoComplete(request);
    }
    /**
     * Performs an autocomplete request for a single vertical.
     *
     * @param request - Vertical autocomplete request options
     */
    verticalAutoComplete(request) {
        return this.autoCompleteService.verticalAutoComplete(request);
    }
    /**
     * Performs an autocomplete request against specified fields within a single vertical.
     *
     * @remarks
     * This differs from the vertical autocomplete because the vertical autocomplete operates on all entity fields whereas
     * filter autocomplete operates only on specified fields.
     *
     * @example
     * A site has a 'products' vertical and would like a way to allow the user to narrow down the results by the product name.
     * The site can add a second search bar powered by filter autocomplete which will include only product names as search
     * suggestions.
     *
     * @param request - Filter autocomplete request options
     */
    filterAutoComplete(request) {
        return this.autoCompleteService.filterAutoComplete(request);
    }
}
exports.AnswersCore = AnswersCore;
